import React from 'react';
import Cookies from 'js-cookie';

import { storage_keys } from '@/constant/configs';

import { ExclamationCircleIcon } from '@heroicons/react/24/outline';
import HeadlessModal from '@/components/shared/HeadlessModal';
import Button from '@/components/ui/Button';
import { useTranslations } from 'next-intl';
import STRINGS from '@/lib/utils/translation';
import {
  removeCustomerAuthCreds,
  removeRestaurantAuthCreds,
} from '@/lib/utils/functions';
import { deleteFCMToken } from '@/lib/utils/fcm-cleanup';

type Props = {
  type: 'customer' | 'res_owner';
  showWarning: boolean;
  setShowWarning: (value: boolean) => void;
};

export default function AuthUserGuard({
  type,
  showWarning,
  setShowWarning,
}: Props) {
  const t = useTranslations();
  const handleContinue = async () => {
    await deleteFCMToken();
    if (type === 'customer') {
      removeRestaurantAuthCreds();
    } else {
      removeCustomerAuthCreds();
      localStorage.removeItem(storage_keys.customer_cart);
    }
    setShowWarning(false);
  };
  return (
    <HeadlessModal
      isOpen={showWarning}
      closeModal={() => setShowWarning(false)}
    >
      <div className="flex flex-col items-center">
        <ExclamationCircleIcon className="mb-[30px] h-10 w-10 text-primary" />
        <h1 className="text-lg">
          You are already signed in as a{' '}
          <span className="font-medium">
            {type === 'customer' ? 'restaurant owner' : 'customer'}
          </span>
        </h1>
        <h2 className="mt-[10px]">
          Press Continue to logout then{' '}
          <span className="font-medium">
            sign in as a {type === 'customer' ? 'customer' : 'restaurant owner'}{' '}
          </span>
        </h2>
        <div className="mt-[30px] flex gap-x-[20px]">
          <Button outline onClick={() => setShowWarning(false)}>
            {t(`${STRINGS.COMMON}.back`)}
          </Button>
          <Button onClick={() => handleContinue()}>
            {t(`${STRINGS.COMMON}.continue`)}
          </Button>
        </div>
      </div>
    </HeadlessModal>
  );
}
